/**
 * Created by dri on 7/31/18.
 */
import * as _ from "lodash";
import {DashboardChannel} from "../models/DashboardChannel";
import {CachingCollection} from "./_BaseCollection";
import {DashboardCollectionOptions} from "./DashboardChannels";
import * as Backbone from "backbone"
export class PriorityInstallDashboards extends CachingCollection<Backbone.Model> {

    urlRoot = '/api/v1/dashboards/channels';

    installId: number;

    url = () => {
        return '/api/v1/dashboards/' + this.installId + '/dashboards';
    };

    constructor(initialModels?: Object[] | any[], options?: any) {
        super(initialModels, _.extend({model: Backbone.Model}, options));
        if (!options) return;
        this.installId = options.installId;
    }

    comparator = (model) => {
        return model.get('order');
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/PriorityDashboardInstalls.ts